import React from 'react';
import { Text, Divider } from 'wix-style-react';
import { ItemsSection } from './ItemsSection';
import s from './ItemsList.scss';
export var ItemsList = function (_a) {
    var sections = _a.sections, showSectionTitle = _a.showSectionTitle;
    return (React.createElement(Text, null, sections.map(function (section, index) {
        var isLastSection = sections.length - 1 === index;
        return (React.createElement("div", { key: section.sectionName + "-" + index },
            React.createElement(ItemsSection, { section: section, showSectionTitle: showSectionTitle }),
            !isLastSection && (React.createElement("div", { className: s.divider },
                React.createElement(Divider, null)))));
    })));
};
//# sourceMappingURL=ItemsList.js.map